export const APP_PATHS = {
  home: '/',
  about: '/about',
  artists: '/artists',
  contact: '/contact',
  competition: '/competition',
  gallery: '/gallery',
};
